// eventBus.js
import mitt from 'mitt';

// Create the event emitter
const eventBus = mitt();

// Define authentication events
export const AUTH_EVENTS = {
  LOGIN_SUCCESS: 'login-success',
  LOGOUT_SUCCESS: 'logout-success',
  REGISTER_SUCCESS: 'register-success',
  AUTH_ERROR: 'auth-error'
};

export { eventBus };